import 'bootstrap/dist/css/bootstrap.css';
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './app/App';
import registerServiceWorker from './registerServiceWorker';
import firebaseConfig from './firebase-config';
import { unregister } from './registerServiceWorker';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');

ReactDOM.render(
  <BrowserRouter basename={baseUrl}>
    <Suspense fallback={"Conectando con la app..."}>
      <App />
    </Suspense>
  </BrowserRouter>,
  rootElement
);

//registerServiceWorker();
unregister();

